module.exports = __webpack_public_path__ + "static/media/5.468e8efe.JPG";